import './edit-user-form.css';
import { Box, Button, Checkbox, FormControlLabel, Grid, TextField, useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { theme } from 'components/app/theme';
import { ReusableSelect as Select } from 'components/reusable/select';
import { useGlobalState } from 'store/reducers/reducer';
import { adminUpdateUser, loadAccounts, loadUser } from 'store/sagas/sagas';
export const EditUserForm = () => {
    const { state, asyncDispatch } = useGlobalState();
    const { id } = useParams();
    const [sid, setSid] = useState('');
    const [email, setEmail] = useState('');
    const [accountId, setAccountId] = useState('');
    const [initialAccountId, setInitialAccountId] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSupport, setIsSupport] = useState(false);
    const [isAccountAdmin, setIsAccountAdmin] = useState(false);
    const [isDownloader, setIsDownloader] = useState(false);
    const [isReviewer, setIsReviewer] = useState(false);
    useEffect(() => {
        const loadUserInfo = async () => {
            try {
                const data = await asyncDispatch(loadUser(id));
                setSid(data.sid);
                setEmail(data.email);
                setAccountId(data.accountId);
                setInitialAccountId(data.initialAccountId);
                setIsDisabled(data.isDisabled);
                setIsAdmin(data.isAdmin);
                setIsAccountAdmin(data.isAccountAdmin);
                setIsDownloader(data.isDownloader);
                setIsReviewer(data.isReviewer);
                setIsSupport(data.isSupport);
            }
            catch (error) {
                console.error(error);
            }
        };
        void loadUserInfo();
    }, [id]);
    useEffect(() => {
        if (!state.accounts && state.user?.isAdmin) {
            asyncDispatch(loadAccounts()).catch(console.error);
        }
    }, [asyncDispatch, state.accounts, state.user?.isAdmin, state]);
    const updateUser = () => {
        asyncDispatch(adminUpdateUser({
            accountId,
            initialAccountId,
            id,
            isAccountAdmin,
            isAdmin,
            isDisabled,
            isDownloader,
            isReviewer,
            isSupport
        })).catch(console.error);
    };
    const breakpoint = useMediaQuery(theme.breakpoints.down('sm'));
    return (React.createElement("div", { className: "edit-user-container" },
        React.createElement("h1", null, "Edit User"),
        React.createElement(Box, { className: "filters-container edit-filters" },
            React.createElement(Grid, { alignItems: "flex-start", className: "grid-class-container", container: true, direction: breakpoint ? 'column' : 'row', justifyContent: "space-between", style: {
                    marginBottom: breakpoint ? '1.6rem' : '0',
                    maxWidth: breakpoint ? '100%' : '90rem'
                } },
                React.createElement(Grid, { item: true, md: 2, style: { width: '100%' }, xs: 12 },
                    React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", disabled: true, label: "ID", value: id })),
                React.createElement(Grid, { item: true, md: 2, style: { width: '100%' }, xs: 12 },
                    React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", disabled: true, label: "SID", value: sid })),
                React.createElement(Grid, { item: true, md: 2, style: { width: '100%' }, xs: 12 },
                    React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", disabled: true, label: "Email", value: email })),
                React.createElement(Grid, { item: true, md: 2, style: { width: '100%' }, xs: 12 }, state.accounts && state.account && (React.createElement(Select, { className: "g-full-width", isClearable: false, items: state.accounts.map((a) => ({
                        id: a.id.toString(),
                        name: a.name
                    })), label: "Account Signed Into", name: "pageSize", onChange: (e) => {
                        setAccountId(e.target.value);
                    }, value: accountId }))),
                React.createElement(Grid, { item: true, md: 2, style: { width: '100%' }, xs: 12 }, state.accounts && state.account && (React.createElement(Select, { className: "g-full-width", isClearable: false, items: state.accounts.map((a) => ({
                        id: a.id.toString(),
                        name: a.name
                    })), label: "Account Membership", name: "pageSize", onChange: (e) => {
                        setAccountId(e.target.value);
                        setInitialAccountId(e.target.value);
                    }, value: initialAccountId })))),
            React.createElement(Grid, { className: "grid-class-container", container: true, direction: "column", style: {
                    alignItems: 'start',
                    paddingLeft: '8px'
                } },
                React.createElement(Grid, { container: true, direction: "row", item: true, xs: 2 },
                    React.createElement(FormControlLabel, { className: "form-checkbox", control: React.createElement(Checkbox, { checked: isDisabled, onChange: () => {
                                setIsDisabled(!isDisabled);
                            } }), label: "Disabled" })),
                React.createElement(Grid, { container: true, direction: "row", item: true, xs: 2 },
                    React.createElement(FormControlLabel, { className: "form-checkbox", control: React.createElement(Checkbox, { checked: isAccountAdmin, onChange: () => {
                                setIsAccountAdmin(!isAccountAdmin);
                            } }), label: "Account Admin" })),
                React.createElement(Grid, { container: true, direction: "row", item: true, xs: 2 },
                    React.createElement(FormControlLabel, { className: "form-checkbox", control: React.createElement(Checkbox, { checked: isAdmin, onChange: () => {
                                setIsAdmin(!isAdmin);
                            } }), label: "System Admin" })),
                React.createElement(Grid, { container: true, direction: "row", item: true, xs: 2 },
                    React.createElement(FormControlLabel, { className: "form-checkbox", control: React.createElement(Checkbox, { checked: isSupport, onChange: () => {
                                setIsSupport(!isSupport);
                            } }), label: "Support Admin" })),
                React.createElement(Grid, { container: true, direction: "row", item: true, xs: 2 },
                    React.createElement(FormControlLabel, { className: "form-checkbox", control: React.createElement(Checkbox, { checked: isReviewer, onChange: () => {
                                setIsReviewer(!isReviewer);
                            } }), label: "Reviewer" })),
                React.createElement(Grid, { container: true, direction: "row", item: true, xs: 2 },
                    React.createElement(FormControlLabel, { className: "form-checkbox", control: React.createElement(Checkbox, { checked: isDownloader, onChange: () => {
                                setIsDownloader(!isDownloader);
                            } }), label: "Downloader" }))),
            React.createElement(Box, { marginTop: "1.6rem" },
                React.createElement(Button, { onClick: updateUser }, "Update")))));
};
